export const NAV_TABS = [
  {
    label: 'Overview',
    path: '/project/overview',
  },
  {
    label: 'List',
    path: '/project/details',
  },
  {
    label: 'Board',
    path: '/project/board',
  },
];
